<div class="fullpage narrative" *ngIf="shared.play">
    <h1>Collezione Badge</h1>
    <h2>Il punteggio è {{punteggio}}</h2>
    <div *ngFor="let badge of badges()" >
        <img src="{{environment.gameUrl}}/{{badge.src}}" height="50px" width="50px" />
    </div>
</div>
